import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import errorPageBG from 'src/img/error-bg.jpg';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  errorPage: {
    backgroundImage: "url(".concat(errorPageBG, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '100vw',
    height: '100vh',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  errorNum: {
    fontSize: '96px',
    lineHeight: '96px',
    marginBottom: '10px'
  },
  gradient: {
    background: 'linear-gradient(0deg, #F8F9FA 0%, rgba(255, 255, 255, 0) 100%)',
    width: '100vw',
    height: '100vh',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0'
  },
  errorContent: {
    position: 'relative',
    zIndex: '10',
    textAlign: 'center'
  }
}));
export default useStyles;